import api from '../api';

const MODULE_INTRO_PAGES_SUCCESS = api.events.moduleIntroPages.actionSuccess;

const defaultState = { introPages: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case MODULE_INTRO_PAGES_SUCCESS:
      return { ...state, introPages: action.data };
    default:
      return state;
  }
};
